export default __webpack_public_path__ + "static/media/logo.cc1b5f6f.png";